module.exports = __webpack_public_path__ + "static/media/feihe.5086594.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/feihe.mp4
// module id = 0NIi
// module chunks = 0